import "../Content/icons/sets/board-icons.svg";
import "../Content/icons/sets/content-icons.svg";
import "../Content/icons/sets/cloud-icons.svg";
import "../Content/icons/sets/admin-icons.svg";

export function configTheme($mdThemingProvider: ng.material.IThemingProvider) {
    //debugger;
    //$mdThemingProvider.theme('default')
    //    .primaryPalette('pink')
    //    .accentPalette('orange');

    $mdThemingProvider.alwaysWatchTheme(false);

    const customPrimary = {
        '50': "#a4ccea",
        '100': "#8fc1e6",
        '200': "#7ab5e1",
        '300': "#66a9dc",
        '400': "#519ed8",
        '500': "#3c92d3",
        '600': "#2d86c8",
        '700': "#2978b3",
        '800': "#246a9f",
        '900': "#1f5c8a",
        'A100': "#b9d8ef",
        'A200': "#cee3f4",
        'A400': "#e2eff9",
        'A700': "#1a4e75"
    };
    $mdThemingProvider.definePalette("customPrimary", customPrimary);

    const customAccent = {
        '50': "#fbcf9a",
        '100': "#fbc381",
        '200': "#fab769",
        '300': "#f9ab50",
        '400': "#f8a038",
        '500': "#f7941f",
        '600': "#f48809",
        '700': "#db7a08",
        '800': "#c26d07",
        '900': "#aa5f06",
        'A100': "#fcdbb3",
        'A200': "#fde6cb",
        'A400': "#fef2e4",
        'A700': "#915105"
    };
    $mdThemingProvider.definePalette("customAccent", customAccent);

    const customWarn = {
        '50': "#f6b5af",
        '100': "#f3a098",
        '200': "#f08b81",
        '300': "#ed766b",
        '400': "#eb6154",
        '500': "#e84c3d",
        '600': "#e53726",
        '700': "#d82a1a",
        '800': "#c22617",
        '900': "#ab2114",
        'A100': "#f8cac6",
        'A200': "#fbdfdd",
        'A400': "#fef4f3",
        'A700': "#941d12"
    };
    $mdThemingProvider.definePalette("customWarn", customWarn);

    var customBackground = {
        '50': '#ffffff',
        '100': '#ffffff',
        '200': '#ffffff',
        '300': '#ffffff',
        '400': '#ffffff',
        '500': '#ffffff',
        '600': '#f2f2f2',
        '700': '#e6e6e6',
        '800': '#d9d9d9',
        '900': '#cccccc',
        'A100': '#ffffff',
        'A200': '#ffffff',
        'A400': '#ffffff',
        'A700': '#bfbfbf'
    };
    $mdThemingProvider.definePalette("customBackground", customBackground);

    $mdThemingProvider.theme("default")
        .primaryPalette("customPrimary")
        .accentPalette("customAccent")
        .warnPalette("customWarn");
    //.backgroundPalette("customBackground");



    // $mdThemingProvider.definePalette("warnToastPrimaryPalette", $mdThemingProvider.extendPalette("red", { "500": "3c92d3" }));

    $mdThemingProvider.setDefaultTheme("default");
}


configTheme.$inject = ["$mdThemingProvider"];

export function configIcons($mdIconProvider: ng.material.IIconProvider) {
    $mdIconProvider
        .iconSet("content", require("../Content/icons/sets/content-icons.svg"), 24)
        .iconSet("board", require("../Content/icons/sets/board-icons.svg"), 24)
        .iconSet("admin", require("../Content/icons/sets/admin-icons.svg"), 24)
        .iconSet("board-cloud", require("../Content/icons/sets/cloud-icons.svg"), 24); 
}
configIcons.$inject = ["$mdIconProvider"];



// WEBPACK FOOTER //
// ./app/app-theme.config.ts